import { U21Button } from 'app/shared/u21-ui/components';

interface SupportRequestLinkProps {
  text?: string;
}

export const SupportRequestLink = ({
  text = 'send a request',
}: SupportRequestLinkProps) => (
  <U21Button
    color="primary"
    href="https://support.unit21.ai/hc/en-us/requests/new"
    target="_blank"
    rel="noopener noreferrer"
    variant="text"
  >
    {text}
  </U21Button>
);
